import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import * as React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ButtonDropdown from '@amzn/awsui-components-react/polaris/button-dropdown';
import FileImportModal from '../../../../../../common/components/file_import_modal/FileImportModal';
import { uploadFileToS3Action } from '../../../../../../common/components/file_importer/redux/actions/UploadFileToS3';
import {
  ACCEPTED_IMPORT_FILE_TYPES,
  SUPPORTED_IMPORT_TYPES,
} from '../../../../../import_data/constants/import_types';

import { exportDataAction } from '../../../../../../common/redux/export';
import {
  BC_SEARCH_TYPE_BUSINESS_COMPONENT,
  DEFAULT_BUSINESS_ID,
  DEFAULT_COUNTRY,
} from '../../../../../../common/config/api_constants';
import {
  getStudyPeriod,
  isActionDisabledForStudyPeriod,
} from '../../../../../../common/constants/study_period';
import {
  getImportDropdownItems,
  getUploadToS3PayloadForTriggerImport,
  isImportInProgress,
} from '../../../../../import_data/utils/import_utils';

const BusinessComponentActions = ({
  exportDataBegin,
  query,
  studyPeriod,
  uploadFileToS3,
  config,
  entityId,
}) => {
  const [isFileImportModalVisible, setFileImportModalVisibility] = React.useState(false);
  const [fileImportType, setFileImportType] = React.useState(null);

  // eslint-disable-next-line
  const showFileImportModal = ({ detail }) => {
    setFileImportType(detail.id);
    setFileImportModalVisibility(true);
  };

  const onCancelFileImportModal = () => {
    setFileImportModalVisibility(false);
  };

  const onConfirmFileImportModal = fileState => {
    setFileImportModalVisibility(false);

    uploadFileToS3(
      getUploadToS3PayloadForTriggerImport({
        documentFile: fileState.form.file,
        fileImportType,
      }),
    );
  };

  const onExportHandler = () => {
    exportDataBegin({
      body: {
        type: 'BUSINESS_COMPONENTS_EXTRACT',
        isJSON: false,
        query: {
          studyPeriod,
          country: DEFAULT_COUNTRY,
          clientId: DEFAULT_BUSINESS_ID + (entityId === undefined ? '' : entityId),
          bcItemType: BC_SEARCH_TYPE_BUSINESS_COMPONENT,
          query,
        },
      },
    });
  };

  return (
    <SpaceBetween direction="horizontal" size="xs">
      <ButtonDropdown
        items={getImportDropdownItems(SUPPORTED_IMPORT_TYPES.BUSINESS_COMPONENT, config)}
        onItemClick={showFileImportModal}
        disabled={isActionDisabledForStudyPeriod(studyPeriod) || isImportInProgress(config)}
      >
        Import
      </ButtonDropdown>
      <Button onClick={onExportHandler}>Export</Button>
      <FileImportModal
        isVisible={isFileImportModalVisible}
        onDismiss={onCancelFileImportModal}
        onConfirm={onConfirmFileImportModal}
        onCancel={onCancelFileImportModal}
        acceptedFileTypes={ACCEPTED_IMPORT_FILE_TYPES}
      />
    </SpaceBetween>
  );
};

BusinessComponentActions.propTypes = {
  exportDataBegin: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  studyPeriod: PropTypes.string.isRequired,
  uploadFileToS3: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  entityId: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    studyPeriod: getStudyPeriod(state),
    entityId: get(state, 'entityId.entityId'),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      exportDataBegin: exportDataAction.BEGIN,
      uploadFileToS3: uploadFileToS3Action,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BusinessComponentActions);
